module.exports = __webpack_public_path__ + "static/media/20240503142159_IMG_6665.a239320c.JPG";